import { render, staticRenderFns } from "./ExchangeApplyPopupBefore.vue?vue&type=template&id=f3115c04&"
import script from "./ExchangeApplyPopupBefore.vue?vue&type=script&lang=ts&"
export * from "./ExchangeApplyPopupBefore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports